// import * as caroussel from '../components/owl-caroussel.js';
/* eslint-disable */
import * as lottie from '../components/bodymovin.js';

export default {
  init() {
    // caroussel.init();
    lottie.loop();
    let listAnimation = {};
    $.each($('.anim--startAndLoop'), function (k, v) {
      let name = $(v).attr('id');
      let duration = $(v).data('duration');
      listAnimation[k] = {"name" : name, "duration" : duration}
    });
    for (const i in listAnimation) {
        lottie.start(listAnimation[i].name, listAnimation[i].duration);
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js